import React from 'react';
import { connect } from 'react-redux';
import { generatePath, RouteComponentProps, withRouter } from 'react-router-dom';

import { isFinishedFetching, ResourcesList, ResourcesReduxState } from 'redux-and-the-rest';
import LoadingIndicator from '../shared/LoadingIndicator';
import { ApplicationState } from '../../redux/types';
import { getOrFetchGameScores } from '../../redux/reducers/gameScore';
import { GameScoreModel } from '../../models/gameScoreModel';
import SecondaryNav from './SecondaryNav';
import { MenuItem } from '../../models/menuItem';
import { EDUCATOR_USER } from '../../models/roleModel';
import { Routes } from '../../routes';
import { GameModel } from '../../models/gameModel';
import createSortBy from '../shared/Sorting/utils';
import GameScores from './GameScores';

const SCORES_LIMIT = 100;

interface Props {
  gameScores: ResourcesList<GameScoreModel>;
  gamesList: ResourcesReduxState<GameModel>;
  islandId: string,
  gameId: string,
}

const IslandGameScores = ({
  gameScores, islandId, gameId, gamesList,
}: Props): React.ReactElement => {
  if (!isFinishedFetching(gameScores)) {
    return <LoadingIndicator />;
  }

  // Find the games from the game scores for the Secondary Nav
  const games = gameScores.items.reduce((acc, gameScore) => {
    const { game } = gameScore.values;
    const { id } = game;
    return {
      ...acc,
      [id]: { ...game },
    };
  }, {});

  // Convert that to an array of games
  const gamesArray: GameModel[] = Object.values(games);

  const getGameName = (id: string) => {
    const indexer = parseInt(id, 10);
    return gamesList?.items[indexer]?.values?.name;
  };

  const gamesMenu: MenuItem[] = gamesArray.map(({ id, name }) => ({
    href: generatePath(Routes.Account.Student.GameScore, {
      id: islandId,
      gameId: id,
    }),
    title: name || getGameName(id),
    roles: [EDUCATOR_USER],
  }));

  // Find our game scores, and take the 100 most recent.
  const displayGameScores = gameScores.items
    .filter((gameScore) => gameScore.values.game.id === gameId)
    .map(({ values }) => values)
    .sort(createSortBy('-createdAt'))
    .slice(0, SCORES_LIMIT);

  return (
    <div className="island-game-scores form loadable">
      <SecondaryNav menuItems={gamesMenu} />

      <GameScores gameScores={displayGameScores} />
    </div>
  );
};

const mapStateToProps = (
  { gameScores, games }: ApplicationState,
  { match: { params: { id, gameId } } }: RouteComponentProps<{ id: string; gameId: string}>,
) => ({
  gameScores: getOrFetchGameScores(gameScores, { islandId: id, include: 'game,chosenReward,rewardsToChooseFrom' }),
  islandId: id,
  gameId,
  gamesList: games,
});

export default withRouter(connect(mapStateToProps)(IslandGameScores));
